/**
 * Billing account trial units subview — the account's customer's trial
 * radios. Routed at `/billing/accounts/:accountId/trial`.
 *
 * Contains:
 * - AccountTrialUnitsView — routed child page (default export)
 */
import React from 'react';

import { useBillingAccount } from '@sophocles/views/billing/BillingAccountLayout';
import TrialRadioTable from '@sophocles/views/billing/components/TrialRadioTable';

function AccountTrialUnitsView() {
  const { account } = useBillingAccount();

  return <TrialRadioTable customerId={account?.customer?.id} />;
}

export default AccountTrialUnitsView;
